import axios from '@/axios'
import axiosOriginal from 'axios'
import { Message } from 'element-ui'

// const BASE_URL = 'http://124.70.59.31:8891'
// const BASE_URL = 'http://124.70.59.31:8890' //联调测试
// const BASE_URL = 'http://116.205.109.154:8890' //联调2
const BASE_URL = window.baseURL
// GET请求封装
export function get(url, params, config = {}) {
  return axios({
    method: 'get',
    url: `${BASE_URL}${url}`,
    params,
    ...config
  })
}

// 过滤空值字段的辅助函数
function removeEmptyFields(obj) {
  if (obj === null || obj === undefined) {
    return obj;
  }
  
  if (Array.isArray(obj)) {
    return obj.map(item => removeEmptyFields(item));
  }
  
  if (typeof obj === 'object') {
    const filtered = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        // 保留非空值：不是null、undefined、空字符串
        if (value !== null && value !== undefined && value !== '') {
          filtered[key] = removeEmptyFields(value);
        }
      }
    }
    return filtered;
  }
  
  return obj;
}

// POST请求封装
export function post(url, data, config = {}) {
  return axios({
    method: 'post',
    url: `${BASE_URL}${url}`,
    data: data,
    ...config
  })
}

// 静默GET请求（不显示任何错误提示）
export function getSilent(url, params, config = {}) {
  return axios({
    method: 'get',
    url: `${BASE_URL}${url}`,
    params,
    ...config
  }).catch(error => {
    // 静默处理所有错误，只在控制台记录
    console.warn(`Silent GET request failed: ${url}`, error);
    return Promise.reject(error);
  });
}

// 静默POST请求（不显示任何错误提示）
export function postSilent(url, data, config = {}) {
  return axios({
    method: 'post',
    url: `${BASE_URL}${url}`,
    data: data,
    ...config
  }).catch(error => {
    // 静默处理所有错误，只在控制台记录
    console.warn(`Silent POST request failed: ${url}`, error);
    return Promise.reject(error);
  });
}

// 带业务错误提示的GET请求（只显示业务错误，不显示网络错误）
export function getWithBusinessError(url, params, config = {}) {
  return axios({
    method: 'get',
    url: `${BASE_URL}${url}`,
    params,
    ...config
  }).catch(error => {
    // 只有业务错误才显示提示
     if (error.type === 'business') {
       Message.error(error.message || '操作失败');
     }
    return Promise.reject(error);
  });
}

// 带业务错误提示的POST请求（只显示业务错误，不显示网络错误）
export function postWithBusinessError(url, data, config = {}) {
  return axios({
    method: 'post',
    url: `${BASE_URL}${url}`,
    data: data,
    ...config
  }).catch(error => {
    // 只有业务错误才显示提示
     if (error.type === 'business') {
       Message.error(error.message || '操作失败');
     }
    return Promise.reject(error);
  });
}

// 专门处理blob响应的GET请求（避免响应拦截器的影响）
export function getBlob(url, params, config = {}) {
  return axiosOriginal({
    method: 'get',
    url: `${BASE_URL}${url}`,
    params,
    responseType: 'blob',
    headers: {
      'Authorization': sessionStorage.getItem('token'),
      // 添加缓存控制头，强制不缓存
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0',
      ...config.headers
    },
    ...config
  }).catch(error => {
    console.error(`Blob request failed: ${url}`, error);
    // Message.error('获取文件失败');
    return Promise.reject(error);
  });
}